import { useState } from 'react';
import { ArrowUpRight, Menu, X } from 'lucide-react';
import { NAV, premizeHref } from '@/content/site';

/**
 * Five anchors and one button. The anchors are real `<a href="/#id">`, so they
 * work without JS, are crawlable, and work from the cookie-policy page too
 * (the home page is prerendered, so the target id exists in the first HTML).
 * "Explore PreMize" stays in the bar at every width — on a phone it is not hidden
 * behind the menu. The skip link renders here so every page with the bar has
 * it; each such page has a `<main id="main">`.
 */
export function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <nav aria-label="Main" className="sticky top-0 z-50 border-b border-white/[0.06] bg-background/80 backdrop-blur-md">
        <div className="container-custom flex h-16 items-center justify-between gap-4">
          <a href="/" className="flex items-center gap-2.5" aria-label="AGICAFET home">
            <img src="/img/agicafet-logo-72.webp" width={72} height={72} alt="" className="h-9 w-9" />
            <span className="text-base font-semibold tracking-[-0.02em] text-foreground">AGICAFET</span>
          </a>

          <div className="hidden items-center gap-7 lg:flex">
            {NAV.map((item) => (
              <a key={item.id} href={`/#${item.id}`} className="text-sm font-medium text-[hsl(var(--fg-secondary))] transition-colors hover:text-foreground">
                {item.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-2">
            <a
              href={premizeHref('nav')}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary btn-sm shrink-0 gap-1.5 whitespace-nowrap max-[379px]:px-3"
            >
              {/* Below 340px the full label would run into the wordmark. */}
              <span className="max-[339px]:hidden">Explore PreMize</span>
              <span className="hidden max-[339px]:inline">PreMize</span>
              <ArrowUpRight className="h-3.5 w-3.5 max-[379px]:hidden" />
            </a>
            <button
              type="button"
              className="inline-flex h-10 w-10 items-center justify-center rounded-md text-foreground/80 hover:text-foreground lg:hidden"
              onClick={() => setOpen((v) => !v)}
              aria-expanded={open}
              aria-controls="mobile-menu"
              aria-label={open ? 'Close menu' : 'Open menu'}
            >
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        {open && (
          <div id="mobile-menu" className="border-t border-border/60 bg-background/95 px-6 py-3 lg:hidden">
            <ul className="flex flex-col">
              {NAV.map((item) => (
                <li key={item.id}>
                  <a
                    href={`/#${item.id}`}
                    onClick={() => setOpen(false)}
                    className="block py-2.5 text-foreground/80 transition-colors hover:text-primary"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </nav>
    </>
  );
}
